import { useReducer, useEffect } from 'react';

var makeVar = function (initialValue, equalsFunc) {
    var value = initialValue;
    var subscribers = new Set();
    var reactiveVar = function (newValue) {
        if (newValue !== undefined) {
            var nextValue_1 = value;
            if (newValue instanceof Function) {
                nextValue_1 = newValue(value);
            }
            else {
                nextValue_1 = newValue;
            }
            if (equalsFunc ? !equalsFunc(nextValue_1, value) : nextValue_1 !== value) {
                subscribers.forEach(function (handler) { return handler(nextValue_1); });
            }
            value = nextValue_1;
        }
        return value;
    };
    reactiveVar.subscribe = function (handler) {
        subscribers.add(handler);
        return function () { return subscribers.delete(handler); };
    };
    reactiveVar.unsubscribe = function (handler) {
        subscribers.delete(handler);
    };
    return reactiveVar;
};
var useReactiveVar = function (reactiveVar) {
    var handler = useReducer(function (x) { return x + 1; }, 0)[1];
    useEffect(function () {
        reactiveVar.subscribe(handler);
        return function () {
            reactiveVar.unsubscribe(handler);
        };
    }, []);
    return reactiveVar();
};

export { makeVar, useReactiveVar };
//# sourceMappingURL=index.es.js.map
